import { isCloud } from "../../App";
import dbservice from "./dbservice";
import { useNavigate } from "react-router-dom";

//this class is used to route the data collection even from cloud or local server
class DBManagerInterface {
  //methods
  FetchPieceImageUrl(client, machine, pieceId, onComplete, onError) {
    if (isCloud) {
      const apiUrl = `${process.env.REACT_APP_CLOUD_API_URL}Automata/EndProcess/GetPieceImageUrl?Client=${client}&Machine=${machine}&ID=${pieceId}`;
      console.log("FetchPieceImageUrl Cloud API URL:", apiUrl);
      fetch(apiUrl)
        .then((response) => response.json())
        .then((resp) => {
          if (resp.success === false) {
            if (onError) onError(resp);
          } else {
            if (onComplete) onComplete(resp);
          }
        })
        .catch((error) => {
          console.error("Cloud API error:", error);
          if (onError) onError(error);
           sessionStorage.setItem("Logged", false);
          const navigate = useNavigate();
          navigate("/");
        });
      return;
    }
  }

  //GENERIC POST
  SendPostRequest(
    apiUrl,
    body,
    onComplete,
    onError,
    objToast,
    info,
    queryParams = "",navigate
  ) {
    if (isCloud) {
      apiUrl = process.env.REACT_APP_CLOUD_API_URL + apiUrl;
      if (queryParams && queryParams.length > 0) {
        apiUrl += "?" + queryParams;
      }
      body = JSON.parse(body);
      console.log("Cloud API Request Body:", body);
      console.log("Cloud API URL:", apiUrl);
      // Call cloud API directly
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((resp) => {
          if (resp.success === false) {
            console.log(resp);
            if (onError) onError(resp);
          } else {
            if (onComplete) onComplete(resp);
          }
        })
        .catch((error) => {
          console.error("Cloud API error:", error);
          if (onError) onError(error);
          sessionStorage.setItem("Logged", false);
          if (navigate) navigate("/"); // ✅ safe, no hook used here
        });

      return; // stop here, don’t call dbservice
    }
    dbservice.SendPostRequest(
      apiUrl,
      body,
      (resp) => {
        if (resp.success === false) {
          console.log(resp);
        } else {
          if (onComplete) onComplete(resp);
        }
      },
      onError,
      objToast,
      info
    );
  }
  SendGetRequest(
    apiUrl,
    onComplete,
    onError,
    objToast,
    info,
    queryParams = ""
  ) {
    if (isCloud) {
      apiUrl = process.env.REACT_APP_CLOUD_API_URL + apiUrl;
      if (queryParams && queryParams.length > 0) {
        apiUrl += "?" + queryParams;
      }


      fetch(apiUrl)
        .then((response) => response.json())
        .then((resp) => {
          // ✅ normalize if `data` is accidentally nested
          let cleanResp = resp;
          if (Array.isArray(resp.data)) {
            cleanResp = {
              ...resp,
              data: resp.data.flat(Infinity), // flatten all nested arrays
            };
          }
          if (cleanResp.success === false) {
            if (onError) onError(cleanResp);
          } else {
            if (onComplete) onComplete(cleanResp);
          }
        })
        .catch((error) => {
          console.error("Cloud API error:", error);
          if (onError) onError(error);
           sessionStorage.setItem("Logged", false);
          const navigate = useNavigate();
          navigate("/");
        });

      return;
    }
    dbservice.SendGetRequest(
      apiUrl,
      (resp) => {
        if (resp.success === false) {
          console.log(resp);
        } else {
          if (onComplete) onComplete(resp);
        }
      },
      onError,
      objToast,
      info
    );
  }
  GetAlarms(body, onComplete, onError, objToast, info) {
    if (isCloud) {
      body = JSON.parse(body);
      body.IsCloud = true;
      body = JSON.stringify(body);
      this.SendPostRequest(
        `Automata/Alarms/GetAlarms`,
        body,
        onComplete,
        onError,
        objToast,
        info
      );
    } else {
      dbservice.SendPostRequest(
        `Automata/Alarms/GetAlarms`,
        body,
        (resp) => {
          if (resp.success === false) {
            console.log(resp);
          } else {
            if (onComplete) onComplete(resp);
          }
        },
        onError,
        objToast,
        info
      );
    }
  }
}
let dbManagerInterface = new DBManagerInterface();
export default dbManagerInterface;
